import { render, staticRenderFns } from "./CardComp.vue?vue&type=template&id=cb095bc6&scoped=true&"
import script from "./CardComp.vue?vue&type=script&lang=js&"
export * from "./CardComp.vue?vue&type=script&lang=js&"
import style0 from "./CardComp.vue?vue&type=style&index=0&id=cb095bc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb095bc6",
  null
  
)

export default component.exports